import { Builder } from '@builder.io/react';

import HeroSlider from './index';

Builder.registerComponent(HeroSlider, {
  name: 'Hero Slider',
  inputs: [
    {
      name: 'icon',
      type: 'object',
      subFields: [
        {
          name: 'src',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg']
        },
        {
          name: 'width',
          type: 'number'
        },
        {
          name: 'height',
          type: 'number'
        },
        {
          name: 'alt',
          type: 'string'
        }
      ]
    },
    { name: 'title', type: 'string' },
    { name: 'subtitle', type: 'string' },
    {
      name: 'assets',
      type: 'list',
      subFields: [
        { name: 'asVideo', type: 'boolean' },
        {
          name: 'src',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
          defaultValue:
            'https://cdn.builder.io/api/v1/image/assets%2Fe0438815ba51486bbb6a202747122d4b%2F8eac1a4bb08044fbaf98b047fcd07dd1',
          showIf: "!options.get('asVideo')"
        },
        {
          name: 'srcMobile',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
          defaultValue:
            'https://cdn.builder.io/api/v1/image/assets%2Fe0438815ba51486bbb6a202747122d4b%2F8eac1a4bb08044fbaf98b047fcd07dd1',
          showIf: "!options.get('asVideo')"
        },
        {
          name: 'url',
          type: 'string',
          showIf: "options.get('asVideo')"
        },
        {
          name: 'epigraph',
          type: 'string',
          defaultValue: 'Epigraph'
        },
        {
          name: 'width',
          type: 'number'
        },
        {
          name: 'height',
          type: 'number'
        },
        {
          name: 'alt',
          type: 'string',
          showIf: "!options.get('asVideo')"
        },
        {
          name: 'poster',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
          defaultValue:
            'https://cdn.builder.io/api/v1/image/assets%2Fe0438815ba51486bbb6a202747122d4b%2F8eac1a4bb08044fbaf98b047fcd07dd1',
          showIf: "options.get('asVideo')"
        }
      ],
      defaultValue: []
    },
    {
      name: 'cta',
      type: 'object',
      subFields: [
        {
          name: 'buttons',
          type: 'list',
          defaultValue: [
            {
              text: 'Talk to us',
              href: '/sales',
              variant: 'primary'
            }
          ],
          subFields: [
            {
              name: 'text',
              type: 'string'
            },
            {
              name: 'href',
              type: 'url'
            },
            {
              name: 'variant',
              type: 'string',
              defaultValue: 'primary',
              enum: ['primary', 'secondary', 'inverted']
            }
          ]
        }
      ]
    }
  ]
});
